module.exports = __webpack_public_path__ + "static/media/image 97.e9e5eaa5.webp";